/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllowedConfigs } from './allowedConfigs';


export interface ConfigSpec { 
    key: AllowedConfigs;
    /**
     * Value for the key to be pushed.
     */
    value: string;
}
export namespace ConfigSpec {
}


